import { getLanguage } from "@Views/utils/StringUtils";
import { Detail, OnChangeDateCallback, OnChangeDateRangeCallback } from "react-calendar";
import ReactDatePicker from "react-date-picker";

interface DatePickerProps {
    value: Date;
    className?: string | string[];
    minDate?: Date;
    maxDate?: Date;
    defaultView?: Detail;
    onChange: OnChangeDateCallback | OnChangeDateRangeCallback | undefined;
    format: string | undefined;
    maxDetail: Detail | undefined;
    disabled?: boolean;
    clearIcon?: any;
    onCalendarClose?: any;
}

const DatePicker = (props: DatePickerProps) => {
    const language = getLanguage();

    return <ReactDatePicker
        formatYear={(locale, date) => { return date.getFullYear().toString(); }}
        formatMonth={(locale, date) => { return (date.getMonth() + 1).toString(); }}
        formatDay={(locale, date) => { return date.getDate().toString(); }}
        className={props.className}
        value={props.value}
        minDate={props.minDate}
        maxDate={props.maxDate}
        locale={language}
        onChange={props.onChange}
        format={props.format}
        defaultView={props.defaultView}
        maxDetail={props.maxDetail}
        clearIcon={props.clearIcon}
        calendarIcon={null}
        prev2Label={null}
        next2Label={null}
        disabled={props.disabled}
        onCalendarClose={props.onCalendarClose}
    />;
}

export default DatePicker;